// Newsletter form gate — keeps the submit button disabled until the user has
// entered a valid email address AND solved the reCAPTCHA challenge.
// Exposes two global callbacks for reCAPTCHA: newsletterRecaptchaSuccess and
// newsletterRecaptchaExpired.

var recaptchaSolved = false;

function emailIsValid(input) {
  return input.checkValidity();
}

function updateSubmitState(form) {
  var input = form.querySelector("[data-newsletter-email]");
  var submit = form.querySelector("[data-newsletter-submit]");
  if (!input || !submit) return;
  submit.disabled = !(emailIsValid(input) && recaptchaSolved);
}

export function initNewsletterForm(root) {
  var form = root.querySelector(".n-stories__newsletter-form");
  if (!form) return;

  var input = form.querySelector("[data-newsletter-email]");
  if (!input) return;

  input.addEventListener("input", function() { updateSubmitState(form); });
  input.addEventListener("change", function() { updateSubmitState(form); });

  // Initial state
  updateSubmitState(form);
}

// Global callbacks for reCAPTCHA
window.newsletterRecaptchaSuccess = function() {
  recaptchaSolved = true;
  var form = document.querySelector(".n-stories__newsletter-form");
  if (form) updateSubmitState(form);
};

window.newsletterRecaptchaExpired = function() {
  recaptchaSolved = false;
  var form = document.querySelector(".n-stories__newsletter-form");
  if (form) updateSubmitState(form);
};
